<input class="text-filter-input" type="text" [(ngModel)]="value" (ngModelChange)="valueChanged()" />
